import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "announcement-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "popup-content" }
const _hoisted_6 = ["innerHTML"]

import { ref, onMounted } from 'vue';
import { queryNotice } from '@/api';


export default {
  __name: 'Announcement',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const announcementList = ref('')

onMounted(() => {
  fetchAnnouncement()
})

const fetchAnnouncement = () => {
  queryNotice().then(res => {
    announcementList.value = res.data || []
  })
}



return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")
  const _component_van_swipe = _resolveComponent("van-swipe")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t('announcement.title')), 1),
            _withDirectives(_createVNode(_component_van_icon, {
              class: "close-icon",
              name: "close",
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 512), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_van_swipe, { class: "announcement-swipe" }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(announcementList.value, (item) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    key: item.id
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", {
                        class: "detial-content",
                        innerHTML: item.content
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]),
              _: 1
            })
          ])
        ])
      ]),
      _: 1
    })
  ]))
}
}

}